import React from 'react';
const AcademicCalendar = () => {
  const events = [
    {
      id: 1,
      title: 'Fall Semester Begins',
      date: 'September 5, 2023',
      type: 'semester',
      description: 'First day of classes for Fall semester.'
    },
    {
      id: 2,
      title: 'Last Day to Add/Drop',
      date: 'September 12, 2023',
      type: 'deadline',
      description: 'Last day to add or drop classes without a W grade.'
    },
    {
      id: 3,
      title: 'Midterm Examinations',
      date: 'October 16-20, 2023',
      type: 'exam',
      description: 'Midterm examination period.'
    },
    {
      id: 4,
      title: 'Thanksgiving Break',
      date: 'November 22-26, 2023',
      type: 'holiday',
      description: 'University closed for Thanksgiving holiday.'
    },
    {
      id: 5,
      title: 'Final Examinations',
      date: 'December 11-15, 2023',
      type: 'exam',
      description: 'Final examination period.'
    },
    {
      id: 6,
      title: 'Winter Commencement',
      date: 'December 16, 2023',
      type: 'event',
      description: 'Winter graduation ceremony.'
    }
  ];

  const getEventTypeColor = (type) => {
    switch(type) {
      case 'deadline': return 'bg-red-100 text-red-800';
      case 'exam': return 'bg-blue-100 text-blue-800';
      case 'holiday': return 'bg-green-100 text-green-800';
      case 'event': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Academic Calendar</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Important dates and deadlines for the current academic year.
          </p>
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6 bg-gray-50">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Academic Year 2023-2024
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Key dates for students, faculty, and staff
            </p>
          </div>
          <div className="border-t border-gray-200">
            <ul className="divide-y divide-gray-200">
              {events.map((event) => (
                <li key={event.id} className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                      <div>
                        <div className="flex text-sm">
                          <p className="font-medium text-indigo-600 truncate">{event.title}</p>
                          <p className="ml-2 flex-shrink-0 font-normal text-gray-500">
                            {event.date}
                          </p>
                        </div>
                        <p className="mt-1 text-sm text-gray-500">
                          {event.description}
                        </p>
                      </div>
                    </div>
                    <div className="ml-5 flex-shrink-0">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getEventTypeColor(event.type)}`}>
                        {event.type.charAt(0).toUpperCase() + event.type.slice(1)}
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default AcademicCalendar;
